import React from 'react';
import ProgressCircle from './ProgressCircle';
import styles from './RequestList.module.css';

const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('es-CL');
};

const getStatusClass = (status) => {
    switch (status) {
        case 'COMPLETED': return styles.statusCompleted;
        case 'PROCESSING': return styles.statusProcessing;
        case 'FAILED': return styles.statusFailed;
        default: return styles.statusDefault;
    }
};

const RequestList = ({ requests, showProgress = false, onRequestClick }) => {
    const handleCopy = (text, event) => {
        event.stopPropagation();
        navigator.clipboard.writeText(text);
    };

    const handleCardClick = (requestId) => {
        if (onRequestClick) {
            onRequestClick(requestId);
        }
    };

    if (!requests || requests.length === 0) {
        return <div className={styles.emptyState}>No hay procesos en esta sección.</div>;
    }

    return (
        <div className={styles.listContainer}>
            {requests.map(req => {
                const percentage = req.total_to_process > 0
                    ? (req.processed_count / req.total_to_process) * 100
                    : 0;

                return (
                    <div
                        className={`${styles.requestCard} ${onRequestClick ? styles.clickable : ''}`}
                        key={req.request_id}
                        onClick={() => handleCardClick(req.request_id)}
                        role={onRequestClick ? 'button' : undefined}
                        tabIndex={onRequestClick ? 0 : undefined}
                    >
                        <div className={styles.requestInfo}>
                            <div className={styles.infoRow}>
                                <strong>Request:</strong>
                                <span className={styles.idContainer}>
                                    {req.request_id.slice(0, 8)}...
                                    <button
                                        className={styles.copyButton}
                                        onClick={(e) => handleCopy(req.request_id, e)}
                                        title="Copiar ID completo"
                                    >
                                        <svg className={styles.copyIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            <div className={styles.infoRow}><strong>Solicitado el:</strong> {formatDate(req.created_at)}</div>
                            <div className={styles.infoRow}>
                                <strong>Estado:</strong> <span className={`${styles.statusText} ${getStatusClass(req.status)}`}>{req.status}</span>
                            </div>
                        </div>

                        {showProgress && (req.status === 'PROCESSING' || req.status === 'PENDING') && (
                            <ProgressCircle
                                percentage={percentage}
                                total={req.total_to_process}
                                current={req.processed_count}
                                size={50}
                                color={req.status === 'PENDING' ? '#9E9E9E' : '#4CAF50'}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default RequestList;
